export const SET_ACCESS_TOKEN = "SET_ACCESS_TOKEN";
export const CLEAR_ACCESS_TOKEN = "CLEAR_ACCESS_TOKEN";
export const SET_USER = "SET_USER";
export const SET_ROLES = "SET_ROLES";
export const SET_INITIALIZED = "SET_INITIALIZED";

export const setAccessToken = (token) => ({ type: SET_ACCESS_TOKEN, payload: token });
export const clearAccessToken = () => ({ type: CLEAR_ACCESS_TOKEN });
export const setUser = (user) => ({ type: SET_USER, payload: user });
export const setRoles = (roles) => ({ type: SET_ROLES, payload: roles });
export const setInitialized = () => ({ type: SET_INITIALIZED });